<script setup lang="ts">
import { SideDiscountsProps } from "./SideDiscounts.props"
import { customPaths } from "~/utils/constants"

const props = defineProps<SideDiscountsProps>()
const emit =
  defineEmits<{
    (e: "onClose"): void
    (e: "onClickCTA", index: number): void
  }>()

const onClickDiscountCode = (index: number) => {
  emit("onClose")
  emit("onClickCTA", index)
}

const isLogged = useIsLogged()
const { t } = useI18n()
const discountSidebar = ref<HTMLElement>()

// @ts-ignore
const widthSidebar = ref(
  discountSidebar.value?.parentElement?.getBoundingClientRect().width ?? 0
)

const { width: widthWindow } = useWindowSize()

watch(widthWindow, () => {
  widthSidebar.value =
    discountSidebar.value?.parentElement?.getBoundingClientRect().width ?? 0
})
onMounted(() => {
  widthSidebar.value =
    discountSidebar.value?.parentElement?.getBoundingClientRect().width ?? 0
})

const discountPromoCards = computed(() => {
  return props.additionalDiscountCodes
    ? props.additionalDiscountCodes.map((card) => {
        return {
          image: card.image,
          title: card.title,
          promoCode: card?.discountCode,
          expirationDate: card.expirationDate,
          label: card?.customLabel
        }
      })
    : []
})
</script>

<template>
  <div class="discount-side" ref="discountSidebar">
    <div
      class="
        cta-container
        bg-white
        fixed
        bottom-0
        right-0
        z-20
        hidden
        w-auto
        px-6
        py-4
        shadow-01
        md:block
      "
      :style="widthSidebar ? `width: ${widthSidebar}px` : null"
    >
      <UtilsButton
        theme="link-green"
        :text="$t('discounts.side.bottomButton')"
        class="w-full"
        order="last"
        :path="customPaths.discounts"
        @click="$emit('onClose')"
      >
        <template #icon> <IconsArrowRight class="h-5 w-5" /> </template>
      </UtilsButton>
    </div>
    <div class="flex flex-col justify-between">
      <div class="relative z-10 mb-20">
        <div class="organisms-side_discounts">
          <div class="pl-7 pt-6">
            <div class="mb-5 flex items-center justify-between">
              <p class="hyppo-bold">{{ $t("discounts.side.title") }}</p>
              <UtilsIcon
                name="Close.svg"
                color="green-main"
                @click="$emit('onClose')"
                class="text-green-main h-6 w-6 cursor-pointer"
              />
            </div>
            <div
              v-for="(discount, index) in discounts"
              :key="`discount-code-${discount.discountCode}`"
              class="mb-6"
            >
              <CardDiscountCodeSidebar
                v-bind="discount"
                @on-click-c-t-a="onClickDiscountCode(index)"
                :is-big="false"
                class="-ml-4 md:ml-0"
              />
            </div>
          </div>
        </div>
        <div
          v-if="discountPromoCards?.length > 0"
          class="other-codes py-6 pl-7"
        >
          <div class="promotions-wrapper border-slate-20 border-t-[1px]">
            <div
              class="promotion my-6 flex flex-wrap"
              v-for="(card, index) in discountPromoCards"
              :key="`promotion-${index}`"
            >
              <CardDiscountGridElement v-bind="card" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
